var React = require('react');

function IconLaunch (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M24.333 24.333H5.667V5.667H15V3H5.667A2.666 2.666 0 0 0 3 5.667v18.666A2.666 2.666 0 0 0 5.667 27h18.666A2.675 2.675 0 0 0 27 24.333V15h-2.667zM17.667 3v2.667h4.787L9.347 18.773l1.88 1.88L24.333 7.547v4.787H27V3z","transform":"translate(-3 -3)"}));
}

IconLaunch.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconLaunch;

IconLaunch.default = IconLaunch;
